import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UrlTrackerService {
  private currentUrl: string;

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event:NavigationEnd) => {
        this.currentUrl = event.urlAfterRedirects;
      });
  }

  getCurrentUrl(): string {
    return this.currentUrl;
  }
}
